export default __webpack_public_path__ + "static/media/cf.8dcf2f2f.jpg";